import axios from "axios";

const baseURL = `${(process.env.REACT_APP_BACKEND_URL || "").replace(
  /\/$/,
  ""
)}/api/lms`;

export const lmsApi = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

function readCookie(name) {
  const prefix = `${encodeURIComponent(name)}=`;

  return document.cookie
    .split(";")
    .map((item) => item.trim())
    .find((item) => item.startsWith(prefix))
    ?.slice(prefix.length);
}

lmsApi.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();

  if (!["get", "head", "options"].includes(method)) {
    const csrf = readCookie("trac_csrf");

    if (csrf) {
      config.headers["X-CSRF-Token"] = decodeURIComponent(csrf);
    }
  }

  return config;
});

export default lmsApi;